import clsx from 'clsx';
import { Button } from '../../button/Button';
import { Badge } from '../../badge/Badge';

interface FilterButtonProps {
  onClick: VoidFunction;
  id: string;
  title?: string;
  filterCount?: number;
  className?: string;
  iconOnly?: boolean;
}

export function FilterButton({
  id,
  onClick,
  title = 'Filters',
  filterCount = 0,
  className = '',
  iconOnly = false
}: FilterButtonProps) {
  return (
    <Badge badgeContent={filterCount} overlap='circular' color='primary' data-id='all-filter-count'>
      <Button
        dataId={id}
        className={clsx('position-relative', className)}
        id={id}
        variation='outline'
        size='md'
        icon='filter'
        active={!!filterCount}
        onClick={() => onClick()}
        iconOnly={iconOnly}
      >
        {iconOnly ? '' : title}
      </Button>
    </Badge>
  );
}
